import React from 'react';
import { motion } from 'framer-motion';
import { LuCircleCheck as CheckCircle } from 'react-icons/lu';
import { pricingFeatures } from '../../lib/constants';

const Pricing = ({ onScheduleCall }) => {
  return (
    <section className="py-16 md:py-24 bg-black">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div
          className="text-center mb-12 md:mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 md:mb-4">
            Transparent, Retainer-Based Partnership
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-neutral-400">
            Predictable pricing, unlimited value
          </p>
        </motion.div>

        <motion.div
          className="max-w-2xl mx-auto bg-white/5 border-2 border-white/20 rounded-3xl shadow-2xl p-8 sm:p-10 md:p-12 backdrop-blur-sm"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          whileHover={{ y: -8 }}
        >
          <div className="text-center mb-6 md:mb-8">
            <p className="text-xs md:text-sm uppercase tracking-wide text-white font-semibold mb-2">
              Starting at
            </p>
            <p className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white mb-2">
              $5,500<span className="text-lg sm:text-xl md:text-2xl text-neutral-400">/month</span>
            </p>
            <p className="text-sm md:text-base text-neutral-400">
              25% upfront for first month
            </p>
          </div>

          <div className="space-y-3 md:space-y-4 mb-6 md:mb-8">
            {pricingFeatures.map((feature, index) => (
              <motion.div
                key={index}
                className="flex items-start gap-3"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
              >
                <CheckCircle className="w-5 h-5 md:w-6 md:h-6 text-white flex-shrink-0 mt-0.5" />
                <span className="text-sm md:text-base text-neutral-300">{feature}</span>
              </motion.div>
            ))}
          </div>

          <div className="border-t border-white/10 pt-6 md:pt-8 mb-6 md:mb-8">
            <p className="text-center text-xs md:text-sm text-neutral-400">
              Custom pricing available for enterprise needs
            </p>
          </div>

          <motion.button
            className="w-full btn-primary py-3 md:py-4 text-base md:text-lg font-bold"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={onScheduleCall}
          >
            Book Your Strategy Call
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default Pricing;